import React, { useEffect, useState } from "react";
import styles from "./calculator.module.css";
import InvestmentDetails from "./InvestmentDetails/InvestmentDetails";
import DetailGraph from "./DetailedBreakdown/DetailedBreakDown";
import KnowledgeHub from "./KnowledgeHub/KnowledgeHub";
import { useNavigate } from "react-router-dom";

const Nps = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [investmentAmount, setInvestmentAmount] = useState(500);
  const [expectedReturns, setExpectedReturns] = useState(8);
  const [investmentYears, setInvestmentYears] = useState(18);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className={styles.container}>
      <div
        className={styles.breadCrumb}
        onClick={() => navigate("/calculator")}
      >
        <span class="material-symbols-rounded">chevron_left</span>
        <h1>NPS Calculator</h1>
      </div>

      <InvestmentDetails
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        investmentAmount={investmentAmount}
        setInvestmentAmount={setInvestmentAmount}
        expectedReturns={expectedReturns}
        setExpectedReturns={setExpectedReturns}
        investmentYears={investmentYears}
        setInvestmentYears={setInvestmentYears}
      />

      <DetailGraph
        activeTab={activeTab}
        investmentAmount={investmentAmount}
        expectedReturns={expectedReturns}
        investmentYears={investmentYears}
      />

      <KnowledgeHub />
    </div>
  );
};

export default Nps;
